import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

// ACTION
import { logout } from '../actions/auth';

// COMPONENTS
import { NavBarComponent } from '../components/NavBarComponent.jsx';


class NavBar extends Component {
	constructor(props) {
	  super(props);
	  this.state = {
	  	user:{}
	  };
	}

	componentWillReceiveProps({user}) {
		this.setState({
			user
		})
	}

	render() {
		let { user } = this.state;
		let { logout } = this.props;
		return (
			<div style={{marginBottom:40}}>
				<NavBarComponent
					user		= {user}
					logout		= {logout}
				/>
			</div>
		);
	}
}


function mapStateToProps({user}) {
	return {
		user
	}
};

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ logout }, dispatch)
};

export default connect(mapStateToProps,mapDispatchToProps)(NavBar);
